import * as React from "react";
import {ITransaction} from "../../../../config/transactions";
import { DataTable } from "../../../Components/DataTable";
import { TableCell, styled } from "@mui/material";

const NameCell = styled(TableCell)(() => ({
    paddingLeft: 0,
    width: 130,
}));

const AmountCell = styled(TableCell)(() => ({
}));

interface IAllowancesProps {
    transaction: ITransaction;
}

export const Allowances = ({transaction}: IAllowancesProps) => {
    return (
        <DataTable
            hideHeader
            size="small"
            items={transaction.allowances!.map(item => ({
                name: item.name!,
                amount: item.amount
            }))}
            config={[
                {
                    title: 'Name',
                    fieldName: 'name',
                    component: NameCell,
                },
                {
                    title: 'Amount',
                    fieldName: 'amount',
                    component: AmountCell,
                    render(value: number, item: ITransaction): any {
                        return (value.toCurrency(transaction.original_currency, {}));
                    }
                },
            ]}
        />
    )
};
